export default __webpack_public_path__ + "static/media/profile-large.b2ca24f7.jpg";